import React, {useEffect, useRef} from 'react';
import Box from "@mui/material/Box";
import {
    useGetEventDefinitionQuery,
    useGetEventManagerUserQuery,
    useGetEventResourcesQuery,
    useLazyGetUnpagedAirfieldsQuery,
    useResetManagerPasswordMutation,
    useUpdateEventSetupMutation
} from "../../slices/apiSlice";
import {
    Autocomplete,
    Backdrop,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slider,
    Stack,
    Switch
} from "@mui/material";
import Typography from "@mui/material/Typography";
import {SGP} from "../Competition/sgp-results-react";
import {getEventDatesString} from "../Calendar/index";
import IconButton from "@mui/material/IconButton";
import {ArrowBack, CheckCircle, Close, Edit, Error, PictureAsPdf, Warning} from "@mui/icons-material";
import {findFlagUrlByIso2Code} from 'country-flags-svg';
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import moment from "moment-timezone";
import {countryArray, eventResourceCategory, eventStatus, getCountryName, getRlPilot} from "../../util/standards-util";
import Button from "@mui/material/Button";
import Grid2 from "@mui/material/Unstable_Grid2";
import {useDispatch, useSelector} from "react-redux";
import {hasScope} from "../../hooks/useUserRole";
import UploadWidget, {doUploadFile, prepareFileUploadRequest} from "../../components/Upload/UploadWidget";
import Paper from "@mui/material/Paper";
import EventStatusWidget from "../../components/Event/EventStatusWidget";
import config from "../../config";
import {useNavigate} from "react-router-dom";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {setEvent, setEventRules} from "../../slices/sessionSlice";
import {useUserRole} from "../../hooks/useUserRole";
import ScoringSetupWidget from "../../components/Event/ScoringSetupWidget";



const EventSetup = ({ eventId, onClose, withHeader = false }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const userRole = useUserRole()

    const uploadAction = 'local-procedures'
    const allowedUploadFiletypes = ['pdf']
    const session = useSelector(state => state.session)
    const skip = !hasScope(session, 'SERVICE_SGP_ADMIN')
    const [canUpdate, setCanUpdate] = React.useState()
    const [files, setFiles] = React.useState({})
    const [uploadPromptVisible, setUploadPromptVisible] = React.useState(false)
    const fileInputRef = useRef(null)
    const [updateValues, setUpdateValues] = React.useState({})
    const [isChanged, setIsChanged] = React.useState(false)
    const [airfields, setAirfields] = React.useState([])
    const [practiceDays, setPracticeDays] = React.useState(1)
    const [competitionDays, setCompetitionDays] = React.useState(1)
    const [startDate, setStartDate] = React.useState()
    const [firstRacingDate, setFirstRacingDate] = React.useState()
    const [lastDate, setLastDate] = React.useState()
    const [registrationCloseDate, setRegistrationCloseDate] = React.useState()
    const [handicapped, setHandicapped] = React.useState()
    const [hasResetPassword, setHasResetPassword] = React.useState()
    const [showPasswordResetDialog, setShowPasswordResetDialog] = React.useState()

    const {data, isSuccess} =
        useGetEventDefinitionQuery(eventId)

    const {data: managerUser, isSuccess : isManagerSuccess} =
        useGetEventManagerUserQuery(eventId,{skip})

    const {data: fileData, isSuccess: isFilesSuccess} = useGetEventResourcesQuery({eventId:data?.event.id},{skip: data === undefined})

    const [getAirfields, airfieldsResult] =
        useLazyGetUnpagedAirfieldsQuery()

    const [update, updateResult] =
        useUpdateEventSetupMutation()

    const [resetPassword, resetPasswordResult] =
        useResetManagerPasswordMutation()

    const handleKeyPressed = (e) => {
        if (e.key==='Enter') {
            e.target.blur()
        }
    }

    const saveEdit = () => {
        if (isChanged && data.event.status !== eventStatus.STATUS_COMPLETED) {
            update({
                id: eventId,
                ...updateValues
            })
            setIsChanged(false)
            setUpdateValues({})
        }
    }

    const cancelEdit = () => {
        navigate(0)
    }

    const resetManagerPassword = () => {
        if (hasResetPassword || !userRole.isAdmin) return
        setHasResetPassword(true)
        resetPassword(eventId)
    }

    const handleValueChanged = (e) => {
        const id = e.target.id
        const val = e.target.value
        if (e.target.defaultValue !== val) {
            updateValues[id] = val
            setUpdateValues(updateValues)
            setIsChanged(true)

            console.log(updateValues)
        }
    }

    const handleFirstRacingDateChange = (m) => {
        const startDate = moment(m).subtract(practiceDays,'day')
        const endDate = moment(m).add(competitionDays-1,'day')
        setFirstRacingDate(m)
        setStartDate(startDate)
        setLastDate(endDate)
        updateValues['firstRacingDate'] = m.format('YYYY-MM-DD')
        updateValues['firstDate'] = startDate.format('YYYY-MM-DD')
        updateValues['lastDate'] = endDate.format('YYYY-MM-DD')
        setUpdateValues(updateValues)
        setIsChanged(true)

        console.log(updateValues)
    }

    const handleRegistrationDeadlineChange = (m) => {
        const d = m.format('YYYY-MM-DD')
        setRegistrationCloseDate(d)
        updateValues['registrationCloseDate'] = d
        setUpdateValues(updateValues)
        setIsChanged(true)

        console.log(updateValues)
    }

    const handleHandicappedChange  = (e, value) => {
        updateValues['handicapped'] = value
        setUpdateValues(updateValues)
        setIsChanged(true)
        setHandicapped(value)

        console.log(updateValues)
    }

    const handleAirfieldChange = (e, value) => {
        const afd = value?.airfield
        updateValues['airfield'] = afd
        setUpdateValues(updateValues)
        setIsChanged(true)

        console.log(updateValues)
    }

    const handlePracticeDaysChanged = (event, newValue) => {
        const startDate = moment(data.event.firstRacingDate).subtract(newValue,'day')
        setPracticeDays(newValue)
        updateValues['practiceDays'] = newValue
        updateValues['firstDate'] = startDate.format('YYYY-MM-DD')
        setIsChanged(true)
        setStartDate(startDate)
        console.log(updateValues)
    }

    const handleCompetitionDaysChanged = (event, newValue) => {
        const endDate = moment(data.event.firstRacingDate).add(newValue-1,'day')
        setCompetitionDays(newValue)
        updateValues['competitionDays'] = newValue
        updateValues['lastDate'] = endDate.format('YYYY-MM-DD')
        setIsChanged(true)
        setLastDate(endDate)
        console.log(updateValues)
    }

    const showUploadPrompt =()=>{
        setUploadPromptVisible(true)
    }

    const hideUploadPrompt = () =>{
        setUploadPromptVisible(false)
    }

    const handleFileDropNofitication = (files) =>{
        hideUploadPrompt()
    }

    const handleFilesSelected= (e) => {
        const files = Array.from(e.target.files)

        const fileRequest = prepareFileUploadRequest(files,allowedUploadFiletypes)

        if (fileRequest.length>0){
            //TODO: we will now upload them all at once - change this to a one by one process
            doUploadFile(
                session.token,
                fileRequest[0],
                uploadAction,
                data.event.id,
                undefined,
                (response) =>{
                    console.log('*** Successfully uploaded file:')
                    console.log(response)
                    hideUploadPrompt()
                }
            )
        }

        if (fileInputRef?.current) {
            fileInputRef.current.value = '';
        }

    }

    const download = (url) => {
        window.open(url, "_blank");
    }

    useEffect(() => {
        if (isSuccess){
            getAirfields({country:data.event.country})
            setPracticeDays(data.rules.practiceDays)
            setCompetitionDays(data.rules.competitionDays)
            setStartDate(data.event.firstDate)
            setFirstRacingDate(data.event.firstRacingDate)
            setLastDate(data.event.lastDate)
            setRegistrationCloseDate(data.event.registrationCloseDate)
            setCanUpdate(data.event.status!== eventStatus.STATUS_ACTIVE && data.event.status!== eventStatus.STATUS_COMPLETED)
            setHandicapped(data.rules.handicapped)
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isFilesSuccess){
            const files={
                lps:[],
                airspace:[],
                waypoints:[],
                documents:[],
            }

            fileData.forEach(f => {
                switch(f.category) {
                    case eventResourceCategory.LOCAL_PROCEDURES:
                        files.lps.push(f)
                        break;
                    case eventResourceCategory.AIRSPACE_FILE:
                        files.airspace.push(f)
                        break;
                    case eventResourceCategory.WAYPOINT_LIST:
                        files.waypoints.push(f)
                        break;
                    default:
                        files.documents.push(f)
                }
            })

            setFiles(files)
        }
    }, [isFilesSuccess]);

    useEffect(()=>{
        if (airfieldsResult.isSuccess) {
            const data = airfieldsResult.data.map( a => {return {key:a.i,label:a.n, airfield: a}})
            setAirfields(data)
        }
    },[airfieldsResult])

    useEffect(() => {
        if (updateResult.isSuccess){
            if (updateResult.data.status === "ok") {
                dispatch(setEvent(updateResult.data.event))
                dispatch(setEventRules(updateResult.data.rules))
            }
        }
    }, [updateResult]);

    useEffect(() => {
        if (resetPasswordResult.isSuccess) {
            setShowPasswordResetDialog(true)
        }
    }, [resetPasswordResult]);

    return (
        <>
            {withHeader &&
                <>
                    <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        //justifyContent:'space-between',
                        my:'1em',
                        columnGap:'2em',
                    }}>
                        {onClose &&
                            <IconButton onClick={()=>{onClose()}}><ArrowBack/></IconButton>
                        }
                        <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Event setup</Typography>
                        <ScoringSetupWidget/>
                        {isSuccess && <EventStatusWidget/>}
                        {isChanged &&
                            <Box>
                                <Button onClick={cancelEdit} variant={'outlined'} color={'warning'} size={'small'} sx={{mr:'1em'}}>Cancel</Button>
                                <Button onClick={saveEdit} variant={'contained'} color={'warning'} size={'small'}>Save</Button>
                            </Box>
                        }
                    </Box>
                </>
            }
            {isSuccess &&
                <>
                    {withHeader ?
                        <>
                            <Box sx={{textAlign:'left',bgcolor:'#113248',color:'#ffffff'}} my={3} p={2}>
                                <Stack direction={'row'}>
                                    <Box mr={'24px'}>
                                        <img src='/etc/img/sgp-series-logo-v3.png' alt="SGP" style={{width:'160px'}}/>
                                    </Box>
                                    <Box>
                                        <Typography variant={'h5'}>{SGP.getChampionshipTitle(data.event)}</Typography>
                                        <Typography variant={'h5'}>{data.event.fullEditionTitle}</Typography>
                                        <Typography variant={'h6'}>{data.event.venue}</Typography>
                                        <Typography variant={'h6'}>{getEventDatesString(data.event)}</Typography>
                                    </Box>
                                </Stack>
                            </Box>
                        </>
                        :
                        <Box sx={{
                            display:'flex',
                            alignItems:'center',
                            mt:'1em',
                            columnGap:'1.5em',
                            mb:'2em',
                        }}>
                            {data.event.country && !data.event.isFinal &&
                                <img src={findFlagUrlByIso2Code(data.event.country)} style={{height:'1.2em'}}/>
                            }
                            <Typography variant={'h5'} flexGrow={data.event.venue ? "" : 1} textAlign={'left'} component={'div'} sx={{display:'flex',alignItems:'center'}}>
                                {data.event.fullEditionTitle}
                            </Typography>
                            {data.event.venue &&
                                <Typography flexGrow={1} variant={'h6'} textAlign={'left'} component={'div'} sx={{display:'flex',alignItems:'center'}}>
                                    ({data.event.venue})
                                </Typography>
                            }
                            <ScoringSetupWidget/>
                            {isSuccess && <EventStatusWidget/>}
                            {isChanged &&
                                <Box>
                                    <Button onClick={cancelEdit} variant={'outlined'} color={'warning'} size={'small'} sx={{mr:'1em'}}>Cancel</Button>
                                    <Button onClick={saveEdit} variant={'contained'} color={'warning'} size={'small'}>Save</Button>
                                </Box>
                            }
                        </Box>
                    }
                    <Grid2 container spacing={6}>
                        <Grid2 xs={12} md={6}>
                            <Paper elevation={2} square sx={{height:'100%'}}>
                                <Stack pt={2} pb={4} px={4} spacing={2}>
                                    <Typography variant={'h6'} component={'div'}>
                                        Identity
                                    </Typography>
                                    <TextField
                                        label="Series"
                                        value={data.event.series}
                                        variant="standard"
                                    />
                                    {userRole.isAdmin && canUpdate  ?
                                        <TextField
                                            id = "fullEditionTitle"
                                            label="Event name"
                                            defaultValue={data.event.fullEditionTitle}
                                            variant="outlined"
                                            onBlur={handleValueChanged} onKeyDown={handleKeyPressed}
                                        />
                                        :
                                        <TextField
                                            label="Event name"
                                            value={data.event.fullEditionTitle}
                                            variant="standard"
                                        />
                                    }
                                    {userRole.isAdmin && canUpdate ?
                                        <TextField
                                            id = "editionTitle"
                                            label="Short event name"
                                            defaultValue={data.event.editionTitle}
                                            variant="outlined"
                                            onBlur={handleValueChanged} onKeyDown={handleKeyPressed}
                                        />
                                        :
                                        <TextField
                                            label="Short event name"
                                            value={data.event.editionTitle}
                                            variant="standard"
                                        />
                                    }
                                    <TextField
                                        label="Country"
                                        value={data.rules.country ?
                                            countryArray.find( c=> c.key === data.rules.country).label :
                                            data.rules.airfield ?
                                                countryArray.find( c=> c.key === data.rules.airfield.c).label :
                                                ''
                                        }
                                        variant="standard"
                                    />
                                    {canUpdate ?
                                        <TextField
                                            id={'venue'}
                                            label="Venue"
                                            defaultValue={data.event.venue ?? data.rules.airfield?.n ?? ''}
                                            variant="outlined"
                                            onBlur={handleValueChanged} onKeyDown={handleKeyPressed}
                                        />
                                        :
                                        <TextField
                                            label="Venue"
                                            value={data.event.venue ?? data.rules.airfield?.n ?? ''}
                                            variant="standard"
                                        />
                                    }
                                    {canUpdate ?
                                        <Autocomplete
                                            disablePortal
                                            selectOnFocus
                                            clearOnBlur
                                            handleHomeEndKeys
                                            id="airfield"
                                            name="airfield"
                                            defaultValue={data.rules.airfield ? {key:data.rules.airfield.i,label:data.rules.airfield.n, airfield: data.rules.airfield} :  undefined}
                                            options={airfields}
                                            renderInput={(params) => <TextField {...params} label="Airfield"  sx={{background:'#ffffff'}}/>}
                                            onChange={handleAirfieldChange}
                                            sx={{background:'#ffffff'}}
                                            fullWidth
                                        />
                                        :
                                        <TextField
                                            label="Venue"
                                            value={data.rules.airfield ? data.rules.airfield.n :  ''}
                                            variant="standard"
                                        />
                                    }
                                </Stack>
                            </Paper>
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <Paper elevation={2} square sx={{height:'100%'}}>
                                <Stack pt={2} pb={4} px={4} spacing={2}>
                                    <Typography variant={'h6'} component={'div'}>
                                        Dates
                                    </Typography>
                                    {canUpdate ?
                                    <>
                                        <Stack direction={'row'} alignItems='center' spacing={2}>
                                            <Slider
                                                value={practiceDays}
                                                step={1}
                                                marks
                                                sx={{width:'5em'}}
                                                min={1}
                                                max={4}
                                                onChange={handlePracticeDaysChanged}
                                            />
                                            <Typography variant={'body1'}>{practiceDays} practice days</Typography>
                                        </Stack>
                                    </>
                                        :
                                        <TextField
                                            label="Practice days"
                                            value={data.rules.practiceDays ?? '-'}
                                            variant="standard"
                                        />
                                    }
                                    {userRole.isAdmin && canUpdate ?
                                        <>
                                            <Stack direction={'row'} alignItems='center' spacing={2}>
                                                <Slider
                                                    value={competitionDays}
                                                    step={1}
                                                    marks
                                                    sx={{width:'5em'}}
                                                    min={6}
                                                    max={9}
                                                    onChange={handleCompetitionDaysChanged}
                                                />
                                                <Typography variant={'body1'}>{competitionDays} competition days</Typography>
                                            </Stack>
                                        </>
                                        :
                                        <TextField
                                            label="Competition days"
                                            value={data.rules.competitionDays ?? '-'}
                                            variant="standard"
                                        />
                                    }

                                    <TextField
                                        label="First competition day"
                                        value={moment(startDate).format('D MMMM YYYY')}
                                        variant="standard"
                                    />
                                    {data.event.firstRacingDate && canUpdate && userRole.isAdmin ?
                                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={true ? "en-gb" : 'en'}>
                                            <DatePicker
                                                id='firstRacingDate'
                                                name="firstRacingDate"
                                                label="First racing day"
                                                onChange={handleFirstRacingDateChange}
                                                sx={{background:'#ffffff',minWidth:'15em'}}
                                                value={moment(firstRacingDate)}/>
                                        </LocalizationProvider>
                                        :
                                        data.event.firstRacingDate &&
                                        <TextField
                                            label="First racing day"
                                            value={moment(data.event.firstRacingDate).format('D MMMM YYYY')}
                                            variant="standard"
                                        />
                                    }
                                    <TextField
                                        label="Last competition day"
                                        value={moment(lastDate).format('D MMMM YYYY')}
                                        variant="standard"
                                    />
                                </Stack>
                            </Paper>
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <Paper elevation={2} square sx={{height:'100%'}}>
                                <Stack pt={2} pb={4} px={4} spacing={2}>
                                    <Typography variant={'h6'} component={'div'}>
                                        Configuration
                                    </Typography>
                                    <TextField
                                        label="Rules"
                                        value={`SGP Rules - Series ${data.event.ruleSpaceId}`}
                                        variant="standard"
                                    />
                                    {canUpdate && userRole.isAdmin ?
                                        <FormControlLabel control={<Switch id='handicapped' name={'handicapped'} checked={handicapped} onChange={handleHandicappedChange}/>} label={<Typography variant={'body2'}>Handicapped</Typography>}/>
                                        :
                                        <FormControlLabel control={<Switch name={'handicapped'} checked={data.rules.handicapped ?? false}/>} label={<Typography variant={'body2'}>Handicapped</Typography>}/>
                                    }
                                    <FormControlLabel control={<Switch name={'isFinal'} checked={data.event.isFinal}/>} label={<Typography variant={'body2'}>Series final</Typography>}/>
                                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={true ? "en-gb" : 'en'}>
                                        <DatePicker id='registrationCloseDate' name="registrationCloseDate" label="Registration deadline" onChange={handleRegistrationDeadlineChange} sx={{background:'#ffffff',minWidth:'15em'}} value={registrationCloseDate ? moment(registrationCloseDate): undefined}/>
                                    </LocalizationProvider>
                                    <TextField
                                        label="Registration link"
                                        value={`${window.location.href.substring(0,window.location.href.lastIndexOf(window.location.pathname))}/eventRegistration/${data.event.id}`}
                                        variant="standard"
                                        sx={{maxWidth:'28em'}}
                                    />
                                </Stack>
                            </Paper>
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <Paper elevation={2} square sx={{height:'100%'}}>
                                <Stack pt={2} pb={4} px={4} spacing={2}>
                                    <Typography variant={'h6'} component={'div'}>
                                        Documents
                                    </Typography>
                                    {files.lps?.length>0 ?
                                        <Box mt={.5} sx={{display:'flex',alignItems:'center', cursor:'pointer'}} onClick={()=>{download(config.s3Url+files.lps[0].objUri)}}>
                                            <Typography variant={'body1'} mr={2}>Local procedures</Typography>
                                            <CheckCircle fontSize={'small'} color={'success'}/>
                                        </Box>
                                        :
                                        <Box sx={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                                            <Box sx={{display:'flex',alignItems:'center', cursor:'pointer'}} onClick={()=>{}}>
                                                <Typography variant={'body1'} mr={2}>Local procedures</Typography>
                                                <Error fontSize={'small'} color={'warning'}/>
                                                <Box ml={2}><Button variant={'outlined'} size={'small'} sx={{p:0}} color={'warning'} onClick={showUploadPrompt}>set</Button></Box>
                                            </Box>
                                            <Backdrop
                                                open={uploadPromptVisible}
                                                onClick={hideUploadPrompt}
                                                onDrop={hideUploadPrompt}
                                            >
                                                <Paper>
                                                    <Box textAlign={'right'}><IconButton><Close size={'small'} onClick={hideUploadPrompt}/></IconButton></Box>
                                                    <Box textAlign={'center'} px={4} pt={1} pb={4}>
                                                        <Typography variant={'body2'}>Drag and drop PDF file into browser window</Typography>
                                                        <Typography variant={'body2'} my={1}>or</Typography>
                                                        <Button variant={'contained'} size={'small'} onClick={(e)=>{e.stopPropagation();fileInputRef?.current.click()}}>
                                                            Select file
                                                            <input type="file" multiple hidden onChange={handleFilesSelected} ref={fileInputRef} />
                                                        </Button>
                                                    </Box>
                                                </Paper>
                                            </Backdrop>
                                        </Box>
                                    }
                                </Stack>
                            </Paper>
                        </Grid2>
                        { isManagerSuccess && managerUser && userRole.isAdmin &&
                            <Grid2 xs={12} md={6}>
                                <Paper elevation={2} square sx={{height:'100%'}}>
                                    <Stack pt={2} pb={4} px={4} spacing={2}>
                                        <Typography variant={'h6'} component={'div'}>
                                            Administration
                                        </Typography>
                                        <TextField
                                            label="Event manager username"
                                            value={managerUser.username}
                                            variant="standard"
                                            sx={{maxWidth:'28em'}}
                                        />
                                        <Box sx={{pt:'.5em'}}>
                                            <Button variant={'outlined'} onClick={resetManagerPassword} sx={{maxWidth:'16em',textTransform:'none'}}>Reset manager password</Button>
                                        </Box>
                                    </Stack>
                                </Paper>
                            </Grid2>
                        }
                    </Grid2>
                    <UploadWidget
                        action={uploadAction}
                        allowedUploadFileTypes={allowedUploadFiletypes}
                        notifyDrop={handleFileDropNofitication}
                    />
                    {
                        data && showPasswordResetDialog &&
                    <Dialog
                        sx={{ '& .MuiDialog-paper': { width: 'xs'} }}
                        maxWidth="md"
                        open={true}
                        >
                    <DialogTitle>The event manager password for {data.event.editionTitle} has been reset</DialogTitle>
                        <DialogContent>
                            <Typography variant={'body1'}>Please note new password:</Typography>
                            <Stack spacing={2} my={2}>
                                <TextField label={'Username'} value={resetPasswordResult.data.username}/>
                                <TextField label={'Password'} value={resetPasswordResult.data.password}/>
                            </Stack>
                            <Typography variant={'body2'}>This is the only time the password will appear</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button variant={'contained'} onClick={()=>{setShowPasswordResetDialog(false)}}>OK</Button>
                        </DialogActions>
                    </Dialog>
                    }
                </>
            }
        </>
    );
};

export default EventSetup;